import { v4 as uuidv4 } from 'uuid';
import type { ReservationAnalyticsSession } from './analyticsTypes.ts';

const VISITOR_KEY = 'reservation_analytics_visitor_id';
const SESSION_KEY = 'reservation_analytics_session';
const SESSION_TTL_MS = 30 * 60 * 1000;

const now = () => Date.now();
const newId = () => (typeof crypto !== 'undefined' && 'randomUUID' in crypto ? crypto.randomUUID() : uuidv4());

const safeStorage = (): Storage | null => {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null;
  } catch {
    return null;
  }
};

export const getReservationAnalyticsSession = (): ReservationAnalyticsSession => {
  const storage = safeStorage();
  const current = now();
  const visitorId = storage?.getItem(VISITOR_KEY) || newId();
  storage?.setItem(VISITOR_KEY, visitorId);

  const parsed = (() => {
    try {
      return JSON.parse(storage?.getItem(SESSION_KEY) || 'null') as ReservationAnalyticsSession | null;
    } catch {
      return null;
    }
  })();

  const session = parsed?.sessionId && parsed.visitorId === visitorId && parsed.expiresAt > current
    ? { ...parsed, lastSeenAt: current, expiresAt: current + SESSION_TTL_MS }
    : { sessionId: newId(), visitorId, lastSeenAt: current, expiresAt: current + SESSION_TTL_MS };

  storage?.setItem(SESSION_KEY, JSON.stringify(session));
  return session;
};
